/** clickAway.js - for handling clicks outside of a React component, e.g. closing a popup when user clicks outside of
    it. To use, call registerClickAwayHandler() in componentDidMount() of the component rendering the top-level DOM
    element corresponding to the "click away" area. And call unregisterClickAwayHandler() in componentWillUnmount().

    Purposefully avoiding HOC and mixins to keep the behavior easy to understand. */

import ReactDOM from 'react-dom';

const _handleClickEvent = (event, component, onClickAway) => {
  const thisElement = ReactDOM.findDOMNode(component);
  if (thisElement && !thisElement.contains(event.target)) {
    if (onClickAway) { onClickAway(event); }
  }
};

/** Call this in componentWillUnmount().
 *
 * @param component   Should match React component in previous call to registerClickAwayHandler().
 */
export const unregisterClickAwayHandler = (component) => {
  if (!component._handleClickEvent) { return; } // Already unregistered.
  document.removeEventListener('mousedown', component._handleClickEvent);
  delete component._handleClickEvent;
};

/** Call this in componentDidMount().
 *
 * @param component   React component that renders top-level DOM element covering area to click away from.
 * @param onClickAway Function to call when user clicks away from component.
 */
export const registerClickAwayHandler = (component, onClickAway) => {
  if (component._handleClickEvent) {
    unregisterClickAwayHandler(component);
  }
  component._handleClickEvent = (event) => {
    _handleClickEvent(event, component, onClickAway);
  };
  document.addEventListener('mousedown', component._handleClickEvent);
};
